import { createSlice } from "@reduxjs/toolkit";

const defaultColumns = [
  "Lead Name",
  "leadsid",
  "Lead Owner",
  "Ekyc stage",
  "Lead Stage",
  "Outsourced Team",
  "Created On",
  "Modified On",
  // "Aappsflyer id",
  "Phone Number",
  "Lead Source",
];

const initialState = {
  selectedColumns: [
    "Lead Name",
    "leadsid",
    "Lead Owner",
    "Ekyc stage",
    "Lead Stage",
    "Outsourced Team",
    "Created On",
    "Modified On",
    // "Aappsflyer id",
    "Phone Number",
    "Lead Source",
  ],
};

export const leadsColumnSlice = createSlice({
  name: "leadsColumn",
  initialState,
  reducers: {
    setLeadTableColumns: (state, action) => {
      state.selectedColumns = action.payload;
    },
    setDefaultLeadTableColumns: (state) => {
      state.selectedColumns = defaultColumns;
    },
  },
});

export const { setLeadTableColumns, setDefaultLeadTableColumns } = leadsColumnSlice.actions;
export default leadsColumnSlice.reducer;
